@if (showCompleted()) {
  <app-modal class="z-50">
    <div class="space-y-6 max-w-lg mx-auto text-center">
      <div class="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h2 class="text-2xl font-bold text-blue-600">
        Tu proceso ya terminó
      </h2>
      <p class="text-gray-700">
        Esta pantalla se va a cerrar porque tu validación de identidad ya acabó.
      </p>
      <p class="text-lg font-semibold text-gray-800">
        Te llevaremos a Fincomercio.com en {{ countdown() }} segundo{{ countdown() === 1 ? '' : 's' }}.
      </p>
    </div>
  </app-modal>
}

@if (showWhatsappWarning()) {
  <app-modal class="z-50">
    <div class="space-y-6 max-w-2xl mx-auto">
      <div class="text-center">
        <div class="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <p class="text-gray-700 mb-6">
          <strong class="font-semibold">✅ Para continuar, serás redirigido a tu navegador predeterminado</strong>
          (Safari, Chrome u otro) donde podrás completar la validación exitosamente.
        </p>
      </div>

      <div class="flex flex-col space-y-3">
        @if (!isAndroidUA()) {
          <a
            [href]="getExternalRedirectUrl()"
            target="_blank"
            rel="noopener noreferrer"
            (click)="onIosExternalLinkClick()"
            class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2 no-underline">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
            <span>🌐 Continuar en navegador externo</span>
          </a>
        } @else {
          <button
            type="button"
            (click)="openInExternalBrowserAndContinue()"
            class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
            <span>🌐 Continuar en navegador externo</span>
          </button>
        }
      </div>

      <p class="text-xs text-center text-gray-500 mt-4">
        Al hacer clic serás redirigido automáticamente. Al finalizar la validación, podrás volver a WhatsApp.
      </p>

      <!-- Fallback visible si la redirección automática no funcionó -->
      @if (showManualFallback()) {
        <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 space-y-3">
          <p class="text-sm text-gray-700">
            <strong>¿No se abrió el navegador?</strong> Toca los
            <strong>tres puntos "⋯"</strong> o el ícono de compartir en la parte
            superior o inferior de esta pantalla y selecciona
            <strong>"Abrir en Safari"</strong> (o "Abrir en Chrome" en Android).
          </p>
          <button
            (click)="copyLinkToClipboard()"
            class="text-sm text-blue-600 underline">
            O copia el enlace y pégalo manualmente en tu navegador
          </button>
        </div>
      }
    </div>
  </app-modal>
}

@if (showFaceGuide()) {
  <app-modal class="z-50">
    <div class="space-y-6 max-w-2xl mx-auto">
      <h2 class="text-2xl font-bold text-blue-600 text-center mb-4">
        Consejos para la validación facial
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-blue-50 p-4 rounded-lg border border-blue-200 shadow-sm">
          <div class="flex flex-col items-center text-center space-y-2">
            <div class="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
            </div>
            <h3 class="font-bold text-gray-800">Buena iluminación</h3>
            <p class="text-sm text-gray-600">
              Busca un lugar bien iluminado, evita sombras en tu rostro y reflejos.
            </p>
          </div>
        </div>
        <div class="bg-blue-50 p-4 rounded-lg border border-blue-200 shadow-sm">
          <div class="flex flex-col items-center text-center space-y-2">
            <div class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 class="font-bold text-gray-800">Tu rostro</h3>
            <p class="text-sm text-gray-600">
              Retira gafas, gorras o cualquier accesorio que cubra tu rostro. Mira directamente a la cámara.
            </p>
          </div>
        </div>
        <div class="bg-blue-50 p-4 rounded-lg border border-blue-200 shadow-sm">
          <div class="flex flex-col items-center text-center space-y-2">
            <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h3 class="font-bold text-gray-800">Documento - Anverso</h3>
            <p class="text-sm text-gray-600">
              Coloca el documento sobre una superficie plana. Asegura que se vea completo y sin reflejos.
            </p>
          </div>
        </div>
        <div class="bg-blue-50 p-4 rounded-lg border border-blue-200 shadow-sm">
          <div class="flex flex-col items-center text-center space-y-2">
            <div class="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
              </svg>
            </div>
            <h3 class="font-bold text-gray-800">Documento - Reverso</h3>
            <p class="text-sm text-gray-600">
              Voltea el documento, asegura que se vea el código de barras y toda la información clara.
            </p>
          </div>
        </div>
        <div class="bg-blue-50 p-4 rounded-lg border border-blue-200 shadow-sm">
          <div class="flex flex-col items-center text-center space-y-2">
            <div class="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v10a2 2 0 01-2 2h-2a2 2 0 01-2-2V6z" />
              </svg>
            </div>
            <h3 class="font-bold text-gray-800">Fondo neutro</h3>
            <p class="text-sm text-gray-600">
              Busca un fondo liso y de color claro. Evita fondos con mucho ruido visual o personas detrás.
            </p>
          </div>
        </div>
        <div class="bg-blue-50 p-4 rounded-lg border border-blue-200 shadow-sm">
          <div class="flex flex-col items-center text-center space-y-2">
            <div class="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 class="font-bold text-gray-800">Manos firmes</h3>
            <p class="text-sm text-gray-600">
              Para una mejor captura, procura no mover el celular y espera unos segundos hasta que la cámara enfoque tu rostro o documento.
            </p>
          </div>
        </div>
      </div>
      <div class="flex justify-center space-x-4 pt-4">
        <button (click)="proceedWithValidation()" class="btn-secundary px-8 py-2">
          Entendido y continuar
        </button>
      </div>
      <p class="text-xs text-center text-gray-500 mt-4">
        Estos consejos te ayudarán a completar la validación de forma exitosa en el menor tiempo posible.
        El proceso tomará aproximadamente 2-3 minutos.
      </p>
    </div>
  </app-modal>
}

<div id="become-sdk-container" class="become-hidden-host" aria-hidden="true"></div>

@if (showOlimpia()) {
  <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
    <div class="relative w-full h-full">
      <iframe
        [src]="validationOlimpiaUrl"
        class="w-full h-full border-none"
        allow="camera; microphone; fullscreen; autoplay"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-modals allow-downloads"
        referrerpolicy="no-referrer-when-downgrade">
      </iframe>
    </div>
  </div>
}

@if (showError()) {
    <app-error-screen
        [title]="titleError"
        [actionLabel]="errorActionLabel"
        [showAdvisor]="showErrorAdvisor"
        (close)="closeIdentityError()"
        [description]="descriptionError">
    </app-error-screen>
}

@if (wowDisplay()) {
  <app-wow (completed)="next()"></app-wow>
}